/* FUSFIT POINTS · llegada con el enlace de «Recomienda y gana» (https://fusfit.com/?ffref=CODIGO). La carga
   layout/theme.liquid en todas las páginas, con la misma regla que los demás bloques (snippets/ff-puntos-visible: casilla
   del tema encendida y programa en «vivo», o contacto de prueba con sesión; nunca mayoristas).
   1. Guarda el código del que recomienda (localStorage; si está bloqueado, una cookie propia) y, cuando el ERP dio el
      código AMIGO-, lo pone como atributo oculto del carrito «_ffref» (el «_» lo esconde en el checkout;
      cart-payment-modal.js copia los atributos y los códigos al carrito con que se paga).
   2. UNA vez por navegador y por código pide al ERP, por el proxy firmado, el código AMIGO- del recomendado
      (POST /apps/storefront-control/puntos?accion=recomendado). El ERP decide: si el que recomienda no está activo
      (programa apagado, o en sombra y no es contacto de prueba) responde «inactivo» y aquí no se pinta nada.
   3. Con el código, lo aplica al carrito por la misma vía que la ruleta (/cart/update.js {discount}; si no queda,
      /discount/CODIGO) y lo vuelve a poner en las visitas siguientes si el carrito lo perdió. El ERP reconoce la
      recomendación por ese código en el pedido (pts_recomendaciones), al quedar cobrado.
   Expone window.ffPuntosAplicar(codigo) para assets/ff-puntos.js (canjes). Sin palabras prohibidas ni cifras fijas: el %
   llega en data-pct (reglas.recomendadoPct del ERP). */
(function () {
  if (window.ffPuntosAplicar) return;
  var CLAVE = 'ff_pts_ref', DIAS = 90, RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var yo = document.currentScript, PCT = Number(yo && yo.getAttribute('data-pct')) || 0;

  function cookie(n) { try { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } }
  function leer() {
    var raw = null;
    try { raw = localStorage.getItem(CLAVE); } catch (e) {}
    if (!raw) raw = cookie(CLAVE);
    try { var o = raw && JSON.parse(raw); if (o && o.ref && Date.now() - o.t < DIAS * 864e5) return o; } catch (e) {}
    return null;
  }
  function guardar(o) {
    var s = JSON.stringify(o);
    try { localStorage.setItem(CLAVE, s); return; } catch (e) {}
    try { document.cookie = CLAVE + '=' + encodeURIComponent(s) + '; path=/; max-age=' + (DIAS * 86400) + '; SameSite=Lax; Secure'; } catch (e) {}
  }
  function cartJs() { return fetch(RAIZ + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function cartPost(u, b) {
    return fetch(RAIZ + u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) })
      .then(function (r) { if (!r.ok) throw new Error('carrito ' + r.status); return r.json(); });
  }
  function tieneCodigo(c, codigo) { return (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === String(codigo).toUpperCase(); }); }
  function avisarTema(c) {
    try { document.dispatchEvent(Object.assign(new Event('cart:update', { bubbles: true }), { detail: { resource: c, sourceId: 'ff-puntos', data: { source: 'ff-puntos', itemCount: c.item_count } } })); } catch (e) {}
  }

  // Aplica un código al carrito sin quitar los que ya tenga (afiliada, ruleta…). Devuelve el carrito final.
  function aplicar(codigo) {
    return cartJs().then(function (c) {
      if (tieneCodigo(c, codigo)) return c;
      var otros = (c.discount_codes || []).map(function (d) { return String(d.code); })
        .filter(function (x) { return x.toUpperCase() !== String(codigo).toUpperCase(); });
      return cartPost('cart/update.js', { discount: otros.concat(codigo).join(',') }).catch(function () { return c; });
    }).then(function (c) {
      if (tieneCodigo(c, codigo)) return c;
      return fetch(RAIZ + 'discount/' + encodeURIComponent(codigo), { credentials: 'same-origin' }).then(cartJs);
    }).then(function (c) { avisarTema(c); return c; });
  }
  window.ffPuntosAplicar = aplicar;

  if (window.__ffMayor) return;

  function aviso(codigo) {
    var d = document.createElement('div');
    d.className = 'ff-pts-aviso';
    d.setAttribute('role', 'status');
    d.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;max-width:440px;margin:0 auto;background:#1A1A1A;color:#fff;' +
      'border-left:6px solid #D4392C;border-radius:8px;padding:14px 44px 14px 16px;font:600 14px/1.4 Montserrat,system-ui,sans-serif;box-shadow:0 10px 30px rgba(0,0,0,.35)';
    var t = document.createElement('p'); t.style.margin = '0';
    t.textContent = (PCT ? 'Tu amigo te regaló un ' + PCT + ' % en tu primera compra.' : 'Tu amigo te regaló un descuento en tu primera compra.') + ' Ya quedó en tu carrito: ';
    var b = document.createElement('b'); b.textContent = codigo; t.appendChild(b);
    var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Cerrar'); x.textContent = '×';
    x.style.cssText = 'position:absolute;top:4px;right:4px;width:44px;height:44px;background:none;border:0;color:#fff;font-size:22px;cursor:pointer';
    x.onclick = function () { d.remove(); };
    d.appendChild(t); d.appendChild(x); document.body.appendChild(d);
    setTimeout(function () { d.remove(); }, 12000);
  }

  // Atributo oculto del carrito con el código de quien recomienda (rastro para el ERP; la recomendación la da el código AMIGO-).
  function marcarCarrito(o) {
    return cartJs().then(function (c) {
      var a = c.attributes || {};
      if (a._ffref === o.ref) return c;
      return cartPost('cart/update.js', { attributes: { _ffref: o.ref } });
    }).catch(function () {});
  }

  function pedirCodigo(o) {
    return fetch(RAIZ + 'apps/storefront-control/puntos?accion=recomendado', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ref: o.ref })
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) { return { status: r.status, j: j }; });
    }).then(function (x) {
      var j = x.j || {};
      if (j.ok && j.codigo) { o.codigo = String(j.codigo); o.estado = 'listo'; guardar(o); return aplicar(o.codigo).then(function () { aviso(o.codigo); }); }
      if (j.ok && j.activo === false) { o.estado = 'inactivo'; guardar(o); return; }
      // 4xx (código malo, tope del día): no se insiste. 5xx o red: se reintenta en la próxima visita, hasta 3 veces.
      o.intentos = (o.intentos || 0) + 1;
      o.estado = x.status >= 500 && o.intentos < 3 ? 'pendiente' : 'rechazado';
      guardar(o);
    }).catch(function () { o.intentos = (o.intentos || 0) + 1; o.estado = o.intentos < 3 ? 'pendiente' : 'rechazado'; guardar(o); });
  }

  try {
    var u = new URLSearchParams(location.search), ref = String(u.get('ffref') || '').trim().toUpperCase();
    var o = leer();
    if (/^[A-Z0-9]{4,16}$/.test(ref)) {
      if (!o || o.ref !== ref) { o = { ref: ref, t: Date.now(), estado: 'pendiente', intentos: 0 }; guardar(o); }
      // El enlace queda limpio en la barra (que no se reenvíe con el código de otra persona).
      try { u.delete('ffref'); history.replaceState(history.state, '', location.pathname + (u.toString() ? '?' + u.toString() : '') + location.hash); } catch (e) {}
    }
    if (!o || (o.estado !== 'pendiente' && o.estado !== 'listo')) return;
    // El atributo _ffref solo se pone cuando el ERP ya dio el código (un código inválido o inactivo no deja rastro).
    (o.estado === 'pendiente' ? pedirCodigo(o) : Promise.resolve()).then(function () {
      if (o.estado === 'listo') return marcarCarrito(o);
    }).then(function () {
      if (o.estado === 'pendiente') return;
      // Visitas siguientes: si el carrito ya tiene productos y perdió el código, se vuelve a poner (una vez por sesión).
      if (o.estado === 'listo' && o.codigo) {
        var k = 'ff_pts_ref_puesto';
        var hecho = ''; try { hecho = sessionStorage.getItem(k) || ''; } catch (e) {}
        return cartJs().then(function (c) {
          if (!c.item_count || tieneCodigo(c, o.codigo) || hecho === c.token) return;
          try { sessionStorage.setItem(k, c.token); } catch (e) {}
          return aplicar(o.codigo);
        });
      }
    }).catch(function () {});
  } catch (e) {}
})();
